import { useMemo } from "react";
import { useFeaturesToggle } from "../hooks/useFeaturesToggle";
import { getCookies } from '@edx/frontend-platform/i18n/lib';
import { getConfig } from "@edx/frontend-platform";

/** returns object with features toggled sa boolean values
 * in hasura table platform_settings
    features_ai_chat
    features_ai_image
    features_ai_course_creator
    features_programs
    features_video_library
    features_document_library
    features_payments
    features_sales_analytics
    features_hide_staff_as_student <-> features_show_only_learners
    features_enable_organizations
    features_show_course_overview
    features_ai_home_page
    features_team_management

 * stored in additional_settings.py
    features_show_grade_column --> config["SHOW_GRADE_COLUMN"]
    features_taxonomy --> config["TAXONOMY"]
    features_ai_studio_enabled --> config["AI_STUDIO_ENABLED"]
    features_enable_ai_home --> config["ENABLE_AI_HOME"]
    features_course_vectorizer_enabled --> config["COURSE_VECTORIZER_ENABLED"]
    features_show_team_management --> config["SHOW_TEAM_MANAGEMENT"]
    features_enable_dark_toggle --> config["BLENDX_ENABLE_DARK_TOGGLE"]
 */

/**
 * @returns {Object} featuresToggled
 * @property {boolean} featuresToggled.features_ai_chat
 * @property {boolean} featuresToggled.features_ai_image
 * @property {boolean} featuresToggled.features_ai_course_creator
 * @property {boolean} featuresToggled.features_programs
 * @property {boolean} featuresToggled.features_video_library
 * @property {boolean} featuresToggled.features_document_library
 * @property {boolean} featuresToggled.features_payments
 * @property {boolean} featuresToggled.features_sales_analytics
 * @property {boolean} featuresToggled.features_hide_staff_as_student
 * @property {boolean} featuresToggled.features_show_only_learners
 * @property {boolean} featuresToggled.features_enable_organizations
 * @property {boolean} featuresToggled.features_show_course_overview
 * @property {boolean} featuresToggled.features_ai_home_page
 * @property {boolean} featuresToggled.features_team_management
 * @property {boolean} featuresToggled.features_taxonomy
 * @property {boolean} featuresToggled.features_ai_studio_enabled
 * @property {boolean} featuresToggled.features_course_vectorizer_enabled
 * @property {boolean} featuresToggled.features_show_grade_column
 * @property {boolean} featuresToggled.features_enable_ai_home
 * @property {boolean} featuresToggled.features_course_vectorizer_enabled
 * @property {boolean} featuresToggled.features_show_team_management
 * @property {boolean} featuresToggled.features_enable_dark_toggle
 * @property {boolean} featuresToggled.features_credly_badges
 * @property {boolean} featuresToggled.features_in_app_badges
 */
export function getFeatureToggle() {

    const orgName = getCookies().get('orgName');
    const { TAXONOMY, AI_STUDIO_ENABLED, COURSE_VECTORIZER_ENABLED, SHOW_GRADE_COLUMN, ENABLE_AI_HOME, SHOW_TEAM_MANAGEMENT, BLENDX_ENABLE_DARK_TOGGLE, CREDLY_BADGES, IN_APP_BADGES } = getConfig();

    const { data, loading, error } = useFeaturesToggle(orgName);
    const featuresToggled = useMemo(() => {
        if (data) {
            return data.reduce((acc, item) => {
                acc[item.settingName] = item.settingValue === "true";
                return acc;
            }, {})
        } else {
            return {}
        }
    }, [data])

    featuresToggled.features_taxonomy = TAXONOMY;
    featuresToggled.features_ai_studio_enabled = AI_STUDIO_ENABLED;
    featuresToggled.features_course_vectorizer_enabled = COURSE_VECTORIZER_ENABLED;
    featuresToggled.features_show_grade_column = SHOW_GRADE_COLUMN;
    featuresToggled.features_enable_ai_home = ENABLE_AI_HOME;
    featuresToggled.features_show_team_management = SHOW_TEAM_MANAGEMENT;
    featuresToggled.features_enable_dark_toggle = BLENDX_ENABLE_DARK_TOGGLE;
    featuresToggled.features_credly_badges = CREDLY_BADGES;
    featuresToggled.features_in_app_badges = IN_APP_BADGES;
    // hide_staff_as_student <-> show_only_learners
    featuresToggled.features_show_only_learners = featuresToggled.features_hide_staff_as_student;

    return featuresToggled;
}
